import axios from "axios";
import authHeader from "./auth-header";

import { API_URL } from "./constants";

class ProductsService {
  fetchProducts(shopifyStoreId) {
    return axios.get(`${API_URL}products/fetch/${shopifyStoreId}`, {
      headers: authHeader(),
    });
  }
  syncProducts(shopifyStoreId) {
    return axios.get(`${API_URL}products/${shopifyStoreId}`, {
      headers: authHeader(),
    });
  }
}

export default new ProductsService();
